/* eslint-disable */
import { useState, useEffect, useRef, Suspense, useCallback, useContext } from "react";
import {
	TextField,
	Paper,
	Grid,
	Button,
	Select,
	MenuItem,
	Tooltip,
	Chip,
	Checkbox,
	CheckboxProps
} from "@material-ui/core";
import { withStyles, Theme } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import { green } from "@material-ui/core/colors";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import UIContext from "../../../contexts/UIContext/UIContext";
import { useLocation } from "react-router-dom";
import { useQuery } from "../../../hooks";
import { api } from "../../../utils/api";
import AuthContext from "../../../contexts/authContext/authContext";
import { SnackbarAPI } from "../../shared";
import { useDebouncedCallback } from "use-debounce";
import { trackPromise } from "react-promise-tracker";
import { ADMIN_DASHBOARD_HEADER } from "../../../constants/caption/dashboardHeader";
import validateEmail from "../../../utils/commonFunctions/validateEmail";
import { SnackbarCloseReason } from "@material-ui/core";

import { SnackbarProps } from "../../../@types/snackbarAPI.types";

import { dependentFormField } from "../../../@types/components/dependentFormField.types";

import SendIcon from "@material-ui/icons/Send";
import EventIcon from "@material-ui/icons/Event";
import PublishIcon from "@material-ui/icons/Publish";

import downloadFile from "../../../utils/commonFunctions/downloadFile";
import shortenFileName from "../../../utils/commonFunctions/shortenFileName";

import "../../../globalStyles/paperFormStyles.css";
import excelToJson from "../../../utils/commonFunctions/excelToJson";
import { LINK } from "../../../config/config";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const CheckDate = (): JSX.Element => {
	const [bulkUploadForm, setBulkUploadForm] = useState({});
	const { user } = useContext(AuthContext); // Extracting logged in user from Central storage.
	const { setDashboardHeader } = useContext(UIContext);
	const [hasSubmitClick, setHasCreateClick] = useState<boolean>(false);
	const [excelFile, setExcelFile] = useState(null);
	const [checkDate, setCheckDate] = useState({
		date1: ""
	});
	const [errorResult, setErrorResult] = useState([]);
	const [result, setResult] = useState([]);
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (
			event: React.SyntheticEvent<Element, Event> | Event | React.SyntheticEvent<any, Event>,
			reason?: SnackbarCloseReason | undefined
		) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});

	const handleDateChange = useCallback(
		(date: MaterialUiPickersDate, name: string) => {
			// console.log(" name ====", name);
			const selectedDate = new Date(date as any);
			const parsedDate =
				selectedDate.getFullYear() + "-" + (selectedDate.getMonth() + 1) + "-" + selectedDate.getDate();

			setCheckDate(Object.assign({}, checkDate, { [name]: parsedDate }));
		},
		[checkDate]
	);

	const handleDocumentChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { files } = event.target;

			if (files) {
				setExcelFile(files[0] as any);
				event.target.value = "";
			}
		},
		[excelFile]
	);

	const handleDeleteDocument = useCallback(() => {
		setExcelFile(null);
	}, [excelFile]);

	const handleSubmitLocation = useCallback(
		async (event: React.MouseEvent<HTMLButtonElement>) => {
			try {
				event.preventDefault();

				// console.log(bulkUploadForm);

				const { date1 } = checkDate;
				const datePayload1 = new Date(date1);

				// const checkDatePayload = {
				// 	date1:
				// 		datePayload1.getFullYear() + "-" + (datePayload1.getMonth() + 1) + "-" + datePayload1.getDate()
				// };

				const checkDatePayload = {
					date1
				};

				// console.log(checkDatePayload);

				const response = await trackPromise(api.checkDate.checkDate(checkDatePayload));

				if (response) {
					alert("Date Added Successfully!");
				}
			} catch (error) {
				// console.log("Something went wrong");
				throw error;
			}
		},
		[checkDate]
	);

	const errorText = (errorResult: { errorType: string; errorText: string; errorSSNs: string[] }[]) => {
		const errorTexts = [];
		for (let i = 0; i < errorResult.length; i++) {
			const element = errorResult[i];
			errorTexts.push(<h2>Error Type: {element.errorType}</h2>);
			errorTexts.push(
				<h3>
					Error Text: <i>{element.errorText}</i>
				</h3>
			);
			errorTexts.push(<h3>SSNs from defective excel rows are: </h3>);
			for (let j = 0; j < element.errorSSNs.length; j++) {
				const ssn = element.errorSSNs[j];
				errorTexts.push(<h4>{ssn}</h4>);
			}
		}
		return <div>{errorTexts}</div>;
	};

	const resultShow = (successResult: any) => {
		const successTexts = [];
		// console.log(successResult);
		for (let i = 0; i < successResult.length; i++) {
			const element = successResult[i];

			successTexts.push(<h3>{element}</h3>);
		}
		return <div>{successTexts}</div>;
	};

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.check_date);
	}, [setDashboardHeader]);

	useEffect(() => {
		setBulkUploadForm(
			Object.assign(
				{},
				{
					"Check Date": [
						{
							label: "Date 1",
							name: "date1",
							placeholder: "Enter the date",
							onChange: (date: MaterialUiPickersDate, name: string) => handleDateChange(date, name),
							value: checkDate.date1,
							type: "date"
						}
					]
				}
			)
		);
	}, [checkDate, handleDateChange]);

	// console.log("check date", checkDate);

	return (
		<div className="create-dependent" id="create-dependent">
			<Suspense fallback={<div />}>
				<SnackbarAPI snackbarProps={snackbarAPICallProps} />
			</Suspense>
			<>
				<div className="pf-action-button-container" id="pf-action-button-container">
					<Button
						className="button-green"
						onClick={handleSubmitLocation}
						variant="contained"
						// disabled={hasSubmitClick}
						// disableElevation={hasSubmitClick}
						style={{
							cursor: hasSubmitClick ? "not-allowed" : "pointer",
							pointerEvents: "unset"
						}}
					>
						<span className="button-label-with-icon">Submit</span>
						<span>
							<SendIcon className="button-icon" />
						</span>
					</Button>
				</div>
				<Grid container spacing={1} className="pf-grid-container">
					{Object.entries(bulkUploadForm).map(([key, value]: any, index) => {
						return (
							<div key={index}>
								<div className="pf-title">{key}</div>
								<Suspense fallback={<div />}>
									<Paper className="pf-paper-container" elevation={3} variant="outlined">
										{value.map((field: dependentFormField, index: number) => {
											return (
												<Grid key={index} item xl={12} lg={12} md={12} sm={12} xs={12}>
													<Grid container spacing={1} className="pf-label">
														<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
															<div
																className={
																	field.name === "middle_name" ||
																	field.name === "address_line_2" ||
																	field.name === "is_tobacco" ||
																	field.name === "is_disabled" ||
																	field.name === "dependent_profile_access" ||
																	field.name === "event_name" ||
																	field.name === "event_date" ||
																	field.name === "event_document"
																		? "pf-label-text"
																		: "pf-label-text required"
																}
																id="pf-label-text"
															>
																{field.name === "excel_file"
																	? field.fieldLabel
																	: field.label}
															</div>
														</Grid>
														<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
															{field.type === "textfield" ? (
																<TextField
																	className="text-field"
																	id={
																		field.name === "country" ||
																		field.schema === "employee"
																			? "disabled-input-text-field"
																			: "input-text-field"
																	}
																	name={field.name}
																	placeholder={field.placeholder}
																	value={field.value}
																	onChange={field.onChange}
																	variant="outlined"
																	InputProps={{
																		readOnly: false
																	}}
																	//style={{ width: "70%", borderRadius: 50 }}
																	//disabled={!isButtonSelected}
																	//disableElevation={!isButtonSelected}
																	style={{
																		width: "340px",
																		borderRadius: 50
																	}}
																	disabled={
																		field.name === "country" ||
																		field.schema === "employee"
																			? true
																			: false
																	}
																/>
															) : field.type === "select" ? (
																<>
																	<Select
																		id="text-align-options"
																		name={field.name}
																		value={field.value}
																		onChange={field.onChange}
																		//disabled={!isButtonSelected}
																		//disableElevation={!isButtonSelected}
																		style={{
																			//cursor: !isButtonSelected ? "not-allowed" : "pointer",
																			pointerEvents: "unset",
																			minWidth: 180,
																			textAlign: "left",
																			// zIndex: 10000,
																			overflowY: "visible"
																		}}
																		MenuProps={{
																			style: { zIndex: 35960 }
																		}}
																		inputProps={{
																			"aria-label": "Without label",
																			readOnly: false
																		}}
																	>
																		<MenuItem value="" disabled>
																			Select Value
																		</MenuItem>
																		{field.options.map((option: string) => (
																			<MenuItem key={option} value={option}>
																				{option}
																			</MenuItem>
																		))}
																	</Select>
																</>
															) : field.type === "date" ? (
																<MuiPickersUtilsProvider utils={DateFnsUtils}>
																	<KeyboardDatePicker
																		className="from-date-input"
																		id="from-date-input"
																		inputVariant="outlined"
																		//label={field.label}
																		placeholder={field.placeholder}
																		name={field.name}
																		format="MM/dd/yyyy"
																		error={false}
																		value={field.value}
																		readOnly={false}
																		onChange={(date) =>
																			field.onChange(date, field.name)
																		}
																		InputProps={{
																			readOnly: true
																		}}
																		InputLabelProps={{
																			shrink: true
																		}}
																		//style={{ width: "340px", borderRadius: 50 }}
																		keyboardIcon={
																			<EventIcon style={{ color: "#7cb342" }} />
																		}
																		KeyboardButtonProps={{
																			"aria-label": "change date"
																		}}
																		// disabled={!isButtonSelected}
																		// disableElevation={!isButtonSelected}
																		style={{
																			// cursor: !isButtonSelected ? "not-allowed" : "pointer",
																			pointerEvents: "unset",
																			width: "340px",
																			borderRadius: 50
																		}}
																		helperText={""}
																	/>
																</MuiPickersUtilsProvider>
															) : field.type === "checkbox" ? (
																<>
																	<div className="check-support" id="check-support">
																		<span>
																			<GreenCheckbox
																				onChange={field.onChange}
																				name={field.name}
																				checked={field.value}
																			/>
																		</span>
																		<span
																			className="pf-label-text"
																			id="pf-label-text"
																		>
																			{field.label}
																		</span>
																	</div>
																</>
															) : field.type === "file" && field.value === null ? (
																<>
																	<input
																		className={"document-upload"}
																		id={"document-upload"}
																		name={field.name}
																		type="file"
																		onChange={handleDocumentChange}
																		style={{ display: "none" }}
																		accept=".xlsx, .csv"
																	/>
																	<label htmlFor={"document-upload"}>
																		<Button
																			className="button"
																			component="span"
																			variant="contained"
																			style={{
																				backgroundColor: "#3A4652",
																				color: "#ffff",
																				width: 210
																			}}
																		>
																			<span
																				className="button-label-with-icon"
																				style={{ color: "#ffff" }}
																			>
																				{field.label}
																			</span>
																			<span>
																				<PublishIcon
																					className="button-icon"
																					style={{ color: "#ffff" }}
																				/>
																			</span>
																		</Button>
																	</label>
																</>
															) : (
																<Grid
																	item
																	className="chipset"
																	xl={4}
																	lg={4}
																	md={12}
																	sm={12}
																	xs={12}
																>
																	{field.value ? (
																		<Tooltip title={"Click to download"} arrow>
																			<Chip
																				label={
																					field.value
																						? shortenFileName(
																								field.value.name
																						  )
																						: "No files added"
																				}
																				onDelete={() => handleDeleteDocument()}
																				onClick={() =>
																					downloadFile(field.value)
																				}
																			/>
																		</Tooltip>
																	) : null}
																</Grid>
															)}
														</Grid>
													</Grid>
												</Grid>
											);
										})}
									</Paper>
								</Suspense>
							</div>
						);
					})}
				</Grid>
				<div style={{ textAlign: "center" }}>
					<div style={{ marginTop: "10px" }}>{errorResult.length > 0 ? errorText(errorResult) : null}</div>
					<div style={{ marginTop: "10px" }}>{result.length > 0 ? resultShow(result) : null}</div>
				</div>
			</>
		</div>
	);
};
export default CheckDate;
